<template>
    <!-- 精品案例 -->
    <div>
           <casesHeder></casesHeder>
            <popUpwindow v-if="popUp_" :lin_k="link_" :codeid="codeid" :cate2="cate2"  @close1="close1"></popUpwindow>
            <casesCennert @handleChange="changeName"></casesCennert>
            <paheFooter></paheFooter>
         
    </div>
</template>
<script>
// 引入案例的头部
import casesHeder from '@/common/cases/cases-heder'
// 引入案例的精选
import casesCennert from '@/common/cases/cases-cennert'
// 引入底部
import paheFooter from '@/common/index/pahe-footer'
//引入案例弹窗
import popUpwindow from '@/common/public/pop-upwindow'
export default {
    name:"cases",
    data(){
        return{
            //弹窗开关
              popUp_:false,
            //传来的类型
              link_:null,
            //传来的id
              codeid:null,
        }
    },
    components:{
        casesHeder,
        casesCennert,
        paheFooter,
        popUpwindow
    },
    methods:{
        changeName(link_){
            this.link_=link_.cate
            this.codeid=link_.ID
            if(link_.cate2 ==undefined){
                this.cate2 = ""
            }else{
                this.cate2=link_.cate2
            }
            this.popUp_ = true
        },
        close1(){
            this.popUp_ = false
        }
    },
    mounted() {
        if(this.$route.query.goid == undefined){
              var cases = localStorage.getItem('cases');
              document.documentElement.scrollTop = cases;
        }else{
              const downloadEle = document.querySelector('#cal')
              document.body.scrollTop = downloadEle.offsetTop-60
              document.documentElement.scrollTop = downloadEle.offsetTop-60
        }
    },
    destroyed() {
        let i1 = document.documentElement.scrollTop;
        localStorage.setItem('cases', i1)
    },
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/cases.vue